var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 16.75A8.25 8.25 0 0 1 .75 8.5 8.25 8.25 0 0 1 9 .25a8.25 8.25 0 0 1 8.25 8.25A8.25 8.25 0 0 1 9 16.75M5.29 9.695H9c.422 0 .75-.336.75-.758V4.079a.74.74 0 0 0-.75-.75.747.747 0 0 0-.758.75v4.11H5.29a.74.74 0 0 0-.75.75c0 .421.328.757.75.757"
  })));
};
export default SvgClock;